module.exports = __webpack_public_path__ + "img/paymentMethods.6d08121e.svg";